const pages = [
  'Authentication/Login',
  'Authentication/SignUp',
  'Authentication/ForgotPass',
  'Authentication/',
  'Members',
  'Content',
  'UploadVideo',
  'PopularBanner',
  'Comment',
  'Voting',
  'Funding',
  'SearchTerms',
  'Event',
  'Warehouse',
  'Sellers',
  'Busk'
];

export default pages;
